module.exports = (RESTService, CitiesService) ->
  'ngInject'
  {
    service: (countryId, cityId) ->
      RESTService.service('provinces', CitiesService.service(countryId).one(cityId))
  }
